const STANDARD_VALUES = [10, 20, 50, 100];
const HIGH_CONVERSION_VALUES = [50, 100, 500, 1000];

const STANDARD_CURRENCIES = ['GBP', 'EUR', 'CAD', 'USD'];
const HIGH_CONVERSION_CURRENCIES = ['MXN', 'ZAR'];

// This could be enhanced (if needed) adding brand and site as params
export const preDefinedAmountsMapper = ({ currencies = [] }) => {
  const map = currencies.reduce((acc, currency) => {
    let values = [];
    if (STANDARD_CURRENCIES.includes(currency)) {
      values = STANDARD_VALUES;
    } else if (HIGH_CONVERSION_CURRENCIES.includes(currency)) {
      values = HIGH_CONVERSION_VALUES;
    }
    return ({
      ...acc,
      [currency]: values,
    });
  }, {});

  return map;
};

export default preDefinedAmountsMapper;
